"use client"

import { indexVar, twoDigit } from "@/components/marketing/landing-v2/cssVars"
import { useReveal } from "@/components/marketing/landing-v2/useReveal"
import type { Landing2Copy } from "@/lib/landing-v2/copy"

export function PrinciplesSection({ copy }: { copy: Landing2Copy }) {
  const headRef = useReveal<HTMLElement>()
  const listRef = useReveal<HTMLDivElement>()

  return (
    <section className="l2-section" id="why">
      <div className="l2-container">
        <header className="l2-section-head" ref={headRef}>
          <span className="l2-label">{copy.principles.label}</span>
          <h2 className="l2-h2">{copy.principles.title}</h2>
          <p className="l2-section-sub">{copy.principles.subtitle}</p>
        </header>

        <div className="l2-principles l2-stagger" ref={listRef}>
          {copy.principles.items.map((item, index) => (
            <article className="l2-principle" key={item.title} style={indexVar(index)}>
              <span className="l2-principle-index">{twoDigit(index + 1)}</span>
              <h3 className="l2-principle-title">{item.title}</h3>
              <p className="l2-principle-body">{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
